import type {
  SearchCompanyResult,
  SearchConversationResult,
  SearchUserResult,
} from 'lib-shared-types-api';

import { searchApi } from 'apis/search';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { SearchViewScope } from '../../search.types';

import { SearchResultsEmpty } from './components/empty/searchResultsEmpty';
import { SearchResultsLoading } from './components/loading/searchResultsLoading';
import { ContactsResults } from './components/types/contacts/contactsResults';
import { ConversationsResults } from './components/types/conversations/conversationsResults';
import styles from './searchResults.module.scss';

type SearchResultsProps = {
  onChangeScope: (scope: SearchViewScope) => void;
};

export const SearchResults = ({
  onChangeScope,
}: SearchResultsProps): JSX.Element => {
  const { params } = useAppSelector((state) => state.search);
  const { scope } = params;

  const { results, isFetching } =
    searchApi.endpoints.readAdvancedSearchResults.useQueryState(
      {
        params,
      },
      {
        selectFromResult: ({ data, ...rest }) => ({
          ...rest,
          results: data?.data.results,
        }),
      },
    );

  if (!results?.length) return <SearchResultsEmpty />;

  return (
    <div className={styles.root}>
      {isFetching && <SearchResultsLoading isOverlay />}

      {scope === 'conversations' && (
        <ConversationsResults
          result={
            results.find(
              ({ hits_type }) => hits_type === 'conversation',
            ) as SearchConversationResult
          }
        />
      )}

      {scope === 'users' && (
        <ContactsResults
          scope="users"
          result={
            results.find(
              ({ hits_type }) => hits_type === 'user',
            ) as SearchUserResult
          }
          onChangeScope={onChangeScope}
        />
      )}

      {scope === 'companies' && (
        <ContactsResults
          scope="companies"
          result={
            results.find(
              ({ hits_type }) => hits_type === 'company',
            ) as SearchCompanyResult
          }
          onChangeScope={onChangeScope}
        />
      )}
    </div>
  );
};
